import React from "react";
import { useFeature } from "store/selectors/hooks";

export const MessagesTabHeader: React.FC = () => {
    const sms = useFeature("sms");
    const fax = useFeature("fax");

    if (sms || fax) {
        return <>Messages</>;
    }

    return <>Emails Sent</>;
};
